export default __webpack_public_path__ + "static/media/home_test.2e0d24f3.png";